import React from 'react';
import PropTypes from 'prop-types';
import { convertDateToDayMonthYear, convertTime } from '../../../../lib/formatDate';

const TradeOffersReceivedDesktop = ({ tradeOffersReceived }) => {
  return (
    tradeOffersReceived.valueSeq().map((tradeOfferReceived) => (
      <div className='trade-post__row' key={ tradeOfferReceived.get('id') }>
        <div className='trade-post__cell trade-post__office'>
          {tradeOfferReceived.getIn(['requestedAppointment', 'office', 'name'])}
        </div>
        <div className='trade-post__cell trade-post__requester'>
          {tradeOfferReceived.getIn(['requester', 'name'])}
        </div>
        <div className='trade-post__cell trade-post__offered-appt'>
          {convertDateToDayMonthYear(tradeOfferReceived.getIn(['offeredAppointment', 'scheduledOn']))}{' '}
          {convertTime(tradeOfferReceived.getIn(['offeredAppointment', 'from']))}

        </div>
        <div className='trade-post__cell trade-post__requested-appt'>
          {convertDateToDayMonthYear(tradeOfferReceived.getIn(['requestedAppointment', 'scheduledOn']))}{' '}
          {convertTime(tradeOfferReceived.getIn(['requestedAppointment', 'from']))}
        </div>
        <div className='trade-post__cell trade-post__status'>
          <span className={ 'trade-post__trade-status trade-post__trade-status--rejected' } >
            {tradeOfferReceived.get('status')}
          </span>
        </div>
      </div>
    ))
  );
};

TradeOffersReceivedDesktop.propTypes = {

};

export default TradeOffersReceivedDesktop;



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/rejected/TradeOffersReceivedDesktop.jsx